<template>
  <a-modal
    class="client-modal-wrapper"
    width="702px"
    :mask-closable="false"
    :visible="isVisibleBrand"
    :footer="null"
    :title="title"
    @cancel="$emit('onCancel')"
  >
    <basic-form
      ref="basicForm"
      :form-data="formData"
    >
      <template #company_id>
        <a-select
          v-decorator="[
            'company_id',
            { rules: [{ required: true, message: '请选择合作企业' }] },
          ]"
          placeholder="请选择合作企业"
          @change="changeCompany"
        >
          <a-select-option
            v-for="item in companyData"
            :key="item.id"
            :value="item.id"
          >
            {{ item.companyInfo.qichacha_name }}
          </a-select-option>
        </a-select>
      </template>
      <template #name>
        <a-input
          v-decorator="[
            'name',
            {
              rules: [
                {
                  required: true,
                  message: '请输入提示物名称',
                },
              ],
            },
          ]"
          placeholder="请输入提示物名称"
        />
      </template>
      <template #type>
        <a-select
          v-decorator="[
            'type',
            { rules: [{ required: true, message: '请选择提示物类型' }] },
          ]"
          placeholder="请选择提示物类型"
        >
          <a-select-option
            v-for="item in brand_reminder_type"
            :key="item.key"
            :value="item.key"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </template>
      <template #link_products>
        <a-select
          v-decorator="[
            'link_products',
            { rules: [{ required: true, message: '请选择产品' }] },
          ]"
          mode="multiple"
          placeholder="请选择产品"
        >
          <a-select-option
            v-for="item in link_products"
            :key="item.id"
            :value="item.id"
          >
            {{ item.title }}
          </a-select-option>
        </a-select>
      </template>
      <template #upload>
        <a-upload
          v-decorator="[
            'attach_doc_ids',
            { rules: [{ required: true, message: '请选择附件' }] ,
              valuePropName: 'fileList',
              getValueFromEvent: normFile,
            },
          ]"
          name="upload"
          :with-credentials="false"
          :data="{fileType:'file',}"
          :action="`${uploadUrl}system/upload`"
          @change="handleChangeUpload"
        >
          <a-button> <a-icon type="upload" /> 点击上传 </a-button>
        </a-upload>
      </template>
      <template #summary>
        <a-textarea
          v-decorator="[
            'summary',
            { rules: [{ required: true, message: '请输入' }] },
          ]"
          rows="6"
          placeholder="请输入"
          maxlength="150"
        />
      </template>
    </basic-form>
    <slot />
  </a-modal>
</template>
<script>
import { companyFormData, serviceFormData } from '../data/index';
export default {
  props: ['isVisibleBrand', 'title', 'companyId'],
  data() {
    return {
      formData: [],
      brand_reminder_type: [],
      link_products: [],
      companyData: [],

    };
  },

  mounted() {
    if (this.$store.state.user.role === 1) {
      this.formData = serviceFormData;
      this.getProductList({company_id: this.companyId});
    } else {
      this.formData = companyFormData;
      // 获取产品
      this.getProductList({company_id: undefined});
    }
    // 获取合作企业
    this.getCompanyList();
    // 获取资料类型
    this.getSystemConfig();

  },
  methods: {
    // 获取合作企业
    async getCompanyList() {
      let result = await this.$http.post('/Company/getCooperationCompanyList');
      if (result.data.status === 1) {
        this.companyData = result.data.data.data_list;
      }
    },
    // 选择企业
    changeCompany(id){
      // 获取产品
      this.getProductList({company_id: id});
    },
    // 获取资料类型
    async getSystemConfig() {
      let result = await this.$http.post('/system/getConfigs');
      if (result.data.status === 1) {
        this.brand_reminder_type = result.data.data.brand_reminder_type;
      }
    },
    // 获取产品
    async getProductList(params) {
      let result = await this.$http.post('/product/getList', params);
      if (result.data.status === 1) {
        this.link_products = result.data.data.data_list.filter((item)=>item.status===1);;
        console.log('TCL: getProductList -> this.link_products', this.link_products);
      }
    },
    // 上传
    handleChangeUpload(event){
      if(event.file.response&&event.file.response.status===0){
        this.$message.warning(event.file.response.msg);
      }
    },
    normFile(e) {
      if (Array.isArray(e)) {
        return e;
      }
      let data=[];
      e.fileList.forEach((item)=>{
        if(item.response&&item.response.status===0){
          return ;
        }else{
          data.push(item);
        }
      });
      e.fileList=data;
      return e && e.fileList;
    },
  },
};
</script>
<style lang="scss" scoped>
.client-modal-wrapper {
  .textarea {
    font-size: 12px;
    font-weight: 400;
    color: rgba(86, 92, 102, 1);
    position: relative;
    top: -37px;
    right: -550px;
  }
}
</style>
